export const SERVER_URL = process.env.REACT_APP_BACKEND_URL

export const BASE_URL = process.env.REACT_APP_BASE_URL

export const BUCKET_NAME = process.env.REACT_APP_BUCKET_NAME

export const AMAZON_END_POINT = process.env.REACT_APP_AMAZON_URL

export const getImageBaseUrl = () => {
  return window.location.origin
}
